/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "title_size_default": "text-mb-headline-xs mb-3",
  "title_colors_default": "",
  "title_variant_default": "text-center",
  "group_size_default": "gap-3",
  "group_colors_default": "",
  "group_variant_default": "flex justify-center",
  "timestamp_label_size_default": "text-mb-headline-2xs",
  "timestamp_label_colors_default": "",
  "timestamp_label_variant_default": "",
  "timestamp_size_default": "w-[66px] h-[56px] rounded-xl text-mb-headline-sm md:text-mb-headline-md !font-bold",
  "timestamp_colors_default": "bg-white",
  "timestamp_variant_default": "flex flex-col items-center justify-center",
  "size_default": "mx-auto mt-8",
  "colors_default": "",
  "variant_default": ""
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "Countdown");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;